<template>
  <nav
    v-if="showPagination"
    class="pagination"
    role="navigation"
    aria-label="pagination"
  >
    <ul class="pagination-list">
      <li>
        <a
          v-if="buttons.length > 0"
          :disabled="currentPage < 2"
          class="pagination-previous"
          @click="previous"
          v-text="previousText"
        />
      </li>
      <li v-if="showFirstPageButton">
        <a
          :aria-label="`${goToText} 1`"
          class="pagination-link"
          @click="goPage(1)"
          v-text="1"
        />
      </li>
      <li v-if="buttons[0] > 2">
        <span class="pagination-ellipsis">
          &hellip;
        </span>
      </li>
      <li
        v-for="button in buttons"
        :key="button"
      >
        <a
          class="pagination-link"
          :class="{ 'is-current': button === currentPage }"
          :aria-label="`${button === currentPage ? pageText : goToText} ${button}`"
          :aria-current="button === currentPage ? 'page' : false"
          @click="goPage(button)"
          v-text="button"
        />
      </li>
      <li v-if="buttons[buttons.length - 1] < pagesTotal - 1">
        <span class="pagination-ellipsis">
          &hellip;
        </span>
      </li>
      <li v-if="showLastPageButton">
        <a
          class="pagination-link"
          :aria-label="`${goToText} ${pagesTotal}`"
          @click="goPage(pagesTotal)"
          v-text="pagesTotal"
        />
      </li>
      <li>
        <a
          v-if="buttons.length > 0"
          :disabled="currentPage > pagesTotal - 1"
          class="pagination-next"
          @click="next"
          v-text="nextText"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    currentPage: {
      type: Number,
      default: 1,
      required: true,
    },
    pagesTotal: {
      type: Number,
      default: 1,
      required: true,
    },
    buttonsMax: {
      type: Number,
      default: 7,
      validator: value => value > 4 && Math.abs(value % 2) === 1,
    },
    nextText: {
      type: String,
      default: '>',
    },
    previousText: {
      type: String,
      default: '<',
    },
    goToText: {
      type: String,
      default: 'Ir a',
    },
    pageText: {
      type: String,
      default: 'Página',
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    buttonsTotal() {
      return this.pagesTotal > this.buttonsMax - 2 ? this.buttonsMax - 2 : this.pagesTotal;
    },

    showFirstPageButton() {
      return this.buttons[0] > 1;
    },

    showLastPageButton() {
      return this.buttons[this.buttons.length - 1] < this.pagesTotal;
    },

    buttons() {
      let firstButton = this.currentPage - Math.floor(this.buttonsTotal / 2);
      let lastButton = firstButton + (this.buttonsTotal - Math.ceil(this.buttonsTotal % 2));

      if (firstButton < 1) {
        firstButton = 1;
        lastButton = firstButton + (this.buttonsTotal - 1);
      }
      if (lastButton > this.pagesTotal) {
        lastButton = this.pagesTotal;
        firstButton = lastButton - (this.buttonsTotal - 1);
      }

      const pages = [];
      for (let page = firstButton; page <= lastButton; page += 1) {
        pages.push(page);
      }

      return pages;
    },
  },

  methods: {
    goPage(page) {
      if (this.currentPage !== page) {
        this.$emit('change', page);
      }
    },
    previous() {
      if (this.currentPage > 1) {
        this.$emit('change', this.currentPage - 1);
      }
    },
    next() {
      if (this.currentPage < this.pagesTotal) {
        this.$emit('change', this.currentPage + 1);
      }
    },
  },
};
</script>

<style scoped>
.pagination-link.is-current {
  color: white!important;
}
</style>
